import type { FC } from 'react'
import type { AgreedPlaceInterventionPreference } from '@dhl/receiver-preference-api'
import { DisplayAgreedPlaceValue } from './DisplayAgreedPlaceValue.js'
import { DisplayNeighbourValue } from './DisplayNeighbourValue.js'

type Props = {
  agreedPlace: AgreedPlaceInterventionPreference | null
}

export const DisplayNotHomeValue: FC<Props> = ({ agreedPlace }) => {
  if (agreedPlace?.ringDoorbell) {
    return <DisplayAgreedPlaceValue data={agreedPlace} hasRingdoorbell />
  }

  return <DisplayNeighbourValue />
}
